<mat-form-field class="activeUntil-form-field form-group" color="accent" [appearance]="'fill'">
    <mat-label>{{ 'users.user-form.activeUntil' | translate }}</mat-label>
    <input matInput [formControlName]="controlKey" [matDatepicker]="picker" />
    <mat-icon matSuffix fontSet="mdi" fontIcon="mdi-calendar-today" (click)="picker.open()"
        style="cursor: pointer; color: #777"></mat-icon>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error>
        {{ 'shared.error.incorrect-date' | translate }}
    </mat-error>
</mat-form-field>